import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { ITimeSavedStats } from '@dadohr/shared/domainTypes/reports';

export const toTimeSavedStatsDoc = generateToDocFn<ITimeSavedStats>();
